import { Country } from '@aw/ads-components/src/enums';
import { InjectionToken } from '@angular/core';

const AW_ATTACHMENT_EXTENSIONS = {
    png: {
        icon: {
            type: 'material',
            name: 'image'
        },
        type: 'image'
    },
    jpeg: {
        icon: {
            type: 'material',
            name: 'image'
        },
        type: 'image'
    },
    jpg: {
        icon: {
            type: 'material',
            name: 'image'
        },
        type: 'image'
    },
    gif: {
        icon: {
            type: 'material',
            name: 'image'
        },
        type: 'image'
    },
    bmp: {
        icon: {
            type: 'material',
            name: 'image'
        },
        type: 'image'
    },
    webp: {
        icon: {
            type: 'material',
            name: 'image'
        },
        type: 'image'
    },
    cr2: {
        icon: {
            type: 'material',
            name: 'image'
        },
        type: 'image'
    },
    tif: {
        icon: {
            type: 'material',
            name: 'image'
        },
        type: 'image'
    },
    jxr: {
        icon: {
            type: 'material',
            name: 'image'
        },
        type: 'image'
    },
    ico: {
        icon: {
            type: 'material',
            name: 'image'
        },
        type: 'image'
    },
    psd: {
        color: 'nocolor',
        icon: {
            type: 'material',
            name: 'image'
        },
        type: 'document'
    },
    doc: {
        color: 'nocolor',
        icon: {
            type: 'custom',
            name: 'doc'
        },
        type: 'document'
    },
    docx: {
        color: 'nocolor',
        icon: {
            type: 'custom',
            name: 'doc'
        },
        type: 'document'
    },
    pdf: {
        color: 'nocolor',
        icon: {
            type: 'custom',
            name: 'pdf'
        },
        type: 'document'
    },
    xls: {
        color: 'nocolor',
        icon: {
            type: 'custom',
            name: 'xsl'
        },
        type: 'document'
    },
    xlsx: {
        color: 'nocolor',
        icon: {
            type: 'custom',
            name: 'xsl'
        },
        type: 'document'
    },
    ppt: {
        color: 'nocolor',
        icon: {
            type: 'custom',
            name: 'ppt'
        },
        type: 'document'
    },
    pptx: {
        color: 'nocolor',
        icon: {
            type: 'custom',
            name: 'ppt'
        },
        type: 'document'
    },
    wav: {
        color: 'nocolor',
        icon: {
            type: 'material',
            name: 'audiotrack'
        },
        type: 'audio'
    },
    mp3: {
        color: 'nocolor',
        icon: {
            type: 'material',
            name: 'audiotrack'
        },
        type: 'audio'
    },
    amr: {
        color: 'nocolor',
        icon: {
            type: 'material',
            name: 'audiotrack'
        },
        type: 'audio'
    },
    m4a: {
        color: 'nocolor',
        icon: {
            type: 'material',
            name: 'audiotrack'
        },
        type: 'audio'
    },
    ogg: {
        color: 'nocolor',
        icon: {
            type: 'material',
            name: 'audiotrack'
        },
        type: 'audio'
    },
    midi: {
        color: 'nocolor',
        icon: {
            type: 'material',
            name: 'audiotrack'
        },
        type: 'audio'
    },
    mp4: {
        color: 'nocolor',
        icon: {
            type: 'material',
            name: 'movie_creation'
        },
        type: 'video'
    },
    webm: {
        color: 'nocolor',
        icon: {
            type: 'material',
            name: 'movie_creation'
        },
        type: 'video'
    },
    m4v: {
        color: 'nocolor',
        icon: {
            type: 'material',
            name: 'movie_creation'
        },
        type: 'video'
    },
    mkv: {
        color: 'nocolor',
        icon: {
            type: 'material',
            name: 'movie_creation'
        },
        type: 'video'
    },
    mov: {
        color: 'nocolor',
        icon: {
            type: 'material',
            name: 'movie_creation'
        },
        type: 'video'
    },
    avi: {
        color: 'nocolor',
        icon: {
            type: 'material',
            name: 'movie_creation'
        },
        type: 'video'
    },
    wmv: {
        color: 'nocolor',
        icon: {
            type: 'material',
            name: 'movie_creation'
        },
        type: 'video'
    },
    flv: {
        color: 'nocolor',
        icon: {
            type: 'material',
            name: 'movie_creation'
        },
        type: 'video'
    },
    mpg: {
        color: 'nocolor',
        icon: {
            type: 'material',
            name: 'movie_creation'
        },
        type: 'video'
    }
};
const AW_NEW_ATTACHMENT_EXTENSIONS = {
    png: {
        type: 'image',
        icon: {
            type: 'material',
            name: 'image'
        }
    },
    jpeg: {
        type: 'image',
        icon: {
            type: 'material',
            name: 'image'
        }
    },
    jpg: {
        type: 'image',
        icon: {
            type: 'material',
            name: 'image'
        }
    },
    gif: {
        type: 'image',
        icon: {
            type: 'material',
            name: 'image'
        }
    },
    bmp: {
        type: 'image',
        icon: {
            type: 'material',
            name: 'image'
        }
    },
    webp: {
        type: 'image',
        icon: {
            type: 'material',
            name: 'image'
        }
    },
    cr2: {
        type: 'image',
        icon: {
            type: 'materialmaterial',
            name: 'image'
        }
    },
    tif: {
        type: 'image',
        icon: {
            type: 'material',
            name: 'image'
        }
    },
    jxr: {
        type: 'image',
        icon: {
            type: 'material',
            name: 'image'
        }
    },
    ico: {
        type: 'image',
        icon: {
            type: 'material',
            name: 'image'
        }
    },
    psd: {
        type: 'image',
        icon: {
            type: 'material',
            name: 'image'
        }
    },
    doc: {
        type: 'document',
        icon: {
            type: 'custom',
            name: 'doc'
        }
    },
    docx: {
        type: 'document',
        icon: {
            type: 'custom',
            name: 'doc'
        }
    },
    pdf: {
        type: 'document',
        icon: {
            type: 'custom',
            name: 'pdf'
        }
    },
    mp4: {
        type: 'video',
        icon: {
            type: 'custom',
            name: 'mp4'
        }
    },
    txt: {
        type: 'document',
        icon: {
            type: 'custom',
            name: 'txt'
        }
    },
    csv: {
        type: 'document',
        icon: {
            type: 'custom',
            name: 'csv'
        }
    },
    odp: {
        type: 'document',
        icon: {
            type: 'custom',
            name: 'odp'
        }
    },
    odt: {
        type: 'document',
        icon: {
            type: 'custom',
            name: 'odt'
        }
    },
    ppt: {
        type: 'document',
        icon: {
            type: 'custom',
            name: 'ppt'
        }
    },
    rar: {
        type: 'archive',
        icon: {
            type: 'custom',
            name: 'rar'
        }
    },
    rft: {
        type: 'document',
        icon: {
            type: 'custom',
            name: 'rft'
        }
    },
    wav: {
        type: 'audio',
        icon: {
            type: 'custom',
            name: 'wav'
        }
    },
    zip: {
        type: 'archive',
        icon: {
            type: 'custom',
            name: 'zip'
        }
    }
};

const CHART_BORDER_SOLID = [1, 0];
const CHART_BORDER_DASH_1 = [20, 3, 3, 3];
const CHART_BORDER_DASH_2 = [12, 4];
const CHART_BORDER_DASH_3 = [2, 2];
const CHART_BORDER_DASH_4 = [4, 4];
const CHART_BORDER_DASH_5 = [8, 2];
const CHART_BORDER_DASH_6 = [23, 8, 8, 8];
const CHART_BORDER_DASH_7 = [4, 3, 4, 8];
const CHART_BORDER_DASH_8 = [12, 3, 3, 12, 3, 3];
const AW_CHART_BORDERS_DEFAULT = [
    CHART_BORDER_SOLID,
    CHART_BORDER_DASH_1,
    CHART_BORDER_DASH_2,
    CHART_BORDER_DASH_3,
    CHART_BORDER_DASH_4,
    CHART_BORDER_DASH_5,
    CHART_BORDER_DASH_6,
    CHART_BORDER_DASH_7,
    CHART_BORDER_DASH_8
];
const AW_CHART_OPTIONS_DEFAULT = {
    responsive: true,
    legend: {
        labels: {
            boxWidth: 32,
            fontSize: 12,
            padding: 24
        }
    },
    animation: {
        duration: 0
    },
    tooltips: {
        backgroundColor: 'rgba(53,65,81,.9)',
        xPadding: 16,
        yPadding: 16,
        caretSize: 0,
        cornerRadius: 3,
        borderColor: 'rgba(0,0,0,0)',
        bodyFontSize: 14,
        multiKeyBackground: 'rgba(0,0,0,0)'
    },
    elements: {
        rectangle: {
            borderWidth: 4
        },
        arc: {
            borderWidth: 4
        },
        point: {
            radius: 4,
            hoverRadius: 6,
            borderWidth: 1
        },
        line: {
            fill: false
        }
    }
};

function testMagicBytes(expected, actual) {
    if (!actual.length || actual.length < expected.length) {
        return false;
    }
    return expected.every((sample, index) => {
        if (!sample) {
            return true;
        }
        if (Array.isArray(sample)) {
            return sample.some((byte) => actual[index] === byte);
        }
        return actual[index] === sample;
    });
}
const MAGIC_BYTES = {
    heif: [
        null,
        null,
        null,
        null,
        0x66,
        0x74,
        0x79,
        0x70,
        [0x68, 0x6d],
        [0x65, 0x69],
        [0x69, 0x66],
        [0x63, 0x66, 0x31]
    ]
};
const ɵ0 = (buffer) => (buffer.length > 4
    && buffer[0] === 0x25
    && buffer[1] === 0x50
    && buffer[2] === 0x44
    && buffer[3] === 0x46), ɵ1 = (buffer) => (buffer.length > 5
    && buffer[0] === 0xd0
    && buffer[1] === 0xcf
    && buffer[2] === 0x11
    && buffer[3] === 0xe0
    && buffer[4] === 0xa1
    && buffer[5] === 0xb1
    && buffer[6] === 0x1a
    && buffer[7] === 0xe1), ɵ2 = (buffer) => (buffer.length > 5
    && buffer[0] === 0xd0
    && buffer[1] === 0xcf
    && buffer[2] === 0x11
    && buffer[3] === 0xe0
    && buffer[4] === 0xa1
    && buffer[5] === 0xb1
    && buffer[6] === 0x1a
    && buffer[7] === 0xe1), ɵ3 = (buffer) => (buffer.length > 5
    && buffer[0] === 0xd0
    && buffer[1] === 0xcf
    && buffer[2] === 0x11
    && buffer[3] === 0xe0
    && buffer[4] === 0xa1
    && buffer[5] === 0xb1
    && buffer[6] === 0x1a
    && buffer[7] === 0xe1), ɵ4 = (buffer) => buffer.length > 2 && buffer[0] === 0x50 && buffer[1] === 0x4b, ɵ5 = (buffer) => buffer.length > 2 && buffer[0] === 0x50 && buffer[1] === 0x4b, ɵ6 = (buffer) => buffer.length > 2 && buffer[0] === 0x50 && buffer[1] === 0x4b, ɵ7 = (buffer) => buffer.length > 2 && buffer[0] === 0x50 && buffer[1] === 0x4b, ɵ8 = (buffer) => (buffer.length > 6
    && buffer[0] === 0x3c
    && buffer[1] === 0x3f
    && buffer[2] === 0x78
    && buffer[3] === 0x6d
    && buffer[4] === 0x6c
    && buffer[5] === 0x20), ɵ9 = (buffer) => (buffer.length > 3
    && buffer[0] === 0x4d
    && buffer[1] === 0x54
    && buffer[2] === 0x68
    && buffer[3] === 0x64), ɵ10 = (buffer) => (buffer.length > 2
    && ((buffer[0] === 0x49 && buffer[1] === 0x44 && buffer[2] === 0x33)
        || (buffer[0] === 0xff && buffer[1] === 0xfb))), ɵ11 = (buffer) => (buffer.length > 10
    && ((buffer[4] === 0x66
        && buffer[5] === 0x74
        && buffer[6] === 0x79
        && buffer[7] === 0x70
        && buffer[8] === 0x4d
        && buffer[9] === 0x34
        && buffer[10] === 0x41)
        || (buffer[0] === 0x4d
            && buffer[1] === 0x34
            && buffer[2] === 0x41
            && buffer[3] === 0x20))), ɵ12 = (buffer) => (buffer.length > 3
    && buffer[0] === 0x4f
    && buffer[1] === 0x67
    && buffer[2] === 0x67
    && buffer[3] === 0x53), ɵ13 = (buffer) => (buffer.length > 11
    && buffer[0] === 0x52
    && buffer[1] === 0x49
    && buffer[2] === 0x46
    && buffer[3] === 0x46
    && buffer[8] === 0x57
    && buffer[9] === 0x41
    && buffer[10] === 0x56
    && buffer[11] === 0x45), ɵ14 = (buffer) => (buffer.length > 11
    && buffer[0] === 0x23
    && buffer[1] === 0x21
    && buffer[2] === 0x41
    && buffer[3] === 0x4d
    && buffer[4] === 0x52
    && buffer[5] === 0x0a), ɵ15 = (buffer) => (buffer.length > 27
    && ((buffer[0] === 0x0
        && buffer[1] === 0x0
        && buffer[2] === 0x0
        && (buffer[3] === 0x18 || buffer[3] === 0x20)
        && buffer[4] === 0x66
        && buffer[5] === 0x74
        && buffer[6] === 0x79
        && buffer[7] === 0x70)
        || (buffer[0] === 0x33
            && buffer[1] === 0x67
            && buffer[2] === 0x70
            && buffer[3] === 0x35)
        || (buffer[0] === 0x0
            && buffer[1] === 0x0
            && buffer[2] === 0x0
            && buffer[3] === 0x1c
            && buffer[4] === 0x66
            && buffer[5] === 0x74
            && buffer[6] === 0x79
            && buffer[7] === 0x70
            && buffer[8] === 0x6d
            && buffer[9] === 0x70
            && buffer[10] === 0x34
            && buffer[11] === 0x32
            && buffer[16] === 0x6d
            && buffer[17] === 0x70
            && buffer[18] === 0x34
            && buffer[19] === 0x31
            && buffer[20] === 0x6d
            && buffer[21] === 0x70
            && buffer[22] === 0x34
            && buffer[23] === 0x32
            && buffer[24] === 0x69
            && buffer[25] === 0x73
            && buffer[26] === 0x6f
            && buffer[27] === 0x6d))), ɵ16 = (buffer) => (buffer.length > 10
    && buffer[0] === 0x0
    && buffer[1] === 0x0
    && buffer[2] === 0x0
    && buffer[3] === 0x1c
    && buffer[4] === 0x66
    && buffer[5] === 0x74
    && buffer[6] === 0x79
    && buffer[7] === 0x70
    && buffer[8] === 0x4d
    && buffer[9] === 0x34
    && buffer[10] === 0x56), ɵ17 = (buffer) => ((buffer.length > 15
    && buffer[0] === 0x1a
    && buffer[1] === 0x45
    && buffer[2] === 0xdf
    && buffer[3] === 0xa3
    && buffer[4] === 0x93
    && buffer[5] === 0x42
    && buffer[6] === 0x82
    && buffer[7] === 0x88
    && buffer[8] === 0x6d
    && buffer[9] === 0x61
    && buffer[10] === 0x74
    && buffer[11] === 0x72
    && buffer[12] === 0x6f
    && buffer[13] === 0x73
    && buffer[14] === 0x6b
    && buffer[15] === 0x61)
    || (buffer.length > 38
        && buffer[31] === 0x6d
        && buffer[32] === 0x61
        && buffer[33] === 0x74
        && buffer[34] === 0x72
        && buffer[35] === 0x6f
        && buffer[36] === 0x73
        && buffer[37] === 0x6b
        && buffer[38] === 0x61)), ɵ18 = (buffer) => (buffer.length > 3
    && buffer[0] === 0x1a
    && buffer[1] === 0x45
    && buffer[2] === 0xdf
    && buffer[3] === 0xa3), ɵ19 = (buffer) => (buffer.length > 7
    && buffer[0] === 0x0
    && buffer[1] === 0x0
    && buffer[2] === 0x0
    && buffer[3] === 0x14
    && buffer[4] === 0x66
    && buffer[5] === 0x74
    && buffer[6] === 0x79
    && buffer[7] === 0x70), ɵ20 = (buffer) => (buffer.length > 10
    && buffer[0] === 0x52
    && buffer[1] === 0x49
    && buffer[2] === 0x46
    && buffer[3] === 0x46
    && buffer[8] === 0x41
    && buffer[9] === 0x56
    && buffer[10] === 0x49), ɵ21 = (buffer) => (buffer.length > 9
    && buffer[0] === 0x30
    && buffer[1] === 0x26
    && buffer[2] === 0xb2
    && buffer[3] === 0x75
    && buffer[4] === 0x8e
    && buffer[5] === 0x66
    && buffer[6] === 0xcf
    && buffer[7] === 0x11
    && buffer[8] === 0xa6
    && buffer[9] === 0xd9), ɵ22 = (buffer) => (buffer.length > 3
    && buffer[0] === 0x46
    && buffer[1] === 0x4c
    && buffer[2] === 0x56
    && buffer[3] === 0x01), ɵ23 = (buffer) => (buffer.length > 3
    && buffer[0] === 0x0
    && buffer[1] === 0x0
    && buffer[2] === 0x1
    && buffer[3] >= 0xb0
    && buffer[3] <= 0xbf), ɵ24 = (buffer) => (buffer.length > 2
    && buffer[0] === 0xff
    && buffer[1] === 0xd8
    && buffer[2] === 0xff), ɵ25 = (buffer) => (buffer.length > 3
    && buffer[0] === 0x89
    && buffer[1] === 0x50
    && buffer[2] === 0x4e
    && buffer[3] === 0x47), ɵ26 = (buffer) => (buffer.length > 20
    && buffer[0] === 0x3c
    && buffer[1] === 0x3f
    && buffer[2] === 0x78
    && buffer[3] === 0x6d
    && buffer[4] === 0x6c
    && buffer[5] === 0x20
    && buffer[6] === 0x76
    && buffer[7] === 0x65
    && buffer[8] === 0x72
    && buffer[9] === 0x73
    && buffer[10] === 0x69
    && buffer[11] === 0x6F
    && buffer[12] === 0x6E
    && buffer[13] === 0x3D
    && buffer[14] === 0x22
    && buffer[15] === 0x31
    && buffer[16] === 0x2E
    && buffer[17] === 0x30
    && buffer[18] === 0x22
    && buffer[19] === 0x20), ɵ27 = (buffer) => (buffer.length > 2
    && buffer[0] === 0x47
    && buffer[1] === 0x49
    && buffer[2] === 0x46), ɵ28 = (buffer) => (buffer.length > 11
    && buffer[8] === 0x57
    && buffer[9] === 0x45
    && buffer[10] === 0x42
    && buffer[11] === 0x50), ɵ29 = (buffer) => (buffer.length > 9
    && ((buffer[0] === 0x49
        && buffer[1] === 0x49
        && buffer[2] === 0x2a
        && buffer[3] === 0x0)
        || (buffer[0] === 0x4d
            && buffer[1] === 0x4d
            && buffer[2] === 0x0
            && buffer[3] === 0x2a))
    && buffer[8] === 0x43
    && buffer[9] === 0x52), ɵ30 = (buffer) => (buffer.length > 3
    && ((buffer[0] === 0x49
        && buffer[1] === 0x49
        && buffer[2] === 0x2a
        && buffer[3] === 0x0)
        || (buffer[0] === 0x4d
            && buffer[1] === 0x4d
            && buffer[2] === 0x0
            && buffer[3] === 0x2a))), ɵ31 = (buffer) => (buffer.length > 1
    && buffer[0] === 0x42
    && buffer[1] === 0x4d), ɵ32 = (buffer) => testMagicBytes(MAGIC_BYTES.heif, buffer), ɵ33 = (buffer) => testMagicBytes(MAGIC_BYTES.heif, buffer), ɵ34 = (buffer) => (buffer.length > 2
    && buffer[0] === 0x49
    && buffer[1] === 0x49
    && buffer[2] === 0xbc), ɵ35 = (buffer) => (buffer.length > 3
    && buffer[0] === 0x38
    && buffer[1] === 0x42
    && buffer[2] === 0x50
    && buffer[3] === 0x53), ɵ36 = (buffer) => (buffer.length > 3
    && buffer[0] === 0x00
    && buffer[1] === 0x00
    && buffer[2] === 0x01
    && buffer[3] === 0x00), ɵ37 = (buffer) => (buffer.length > 3
    && buffer[0] === 0x50
    && buffer[1] === 0x4b
    && buffer[2] === 0x03
    && buffer[3] === 0x04);
const SUPPORTED_FILE_TYPES = [
    {
        name: 'pdf',
        mime: 'application/pdf',
        extension: 'pdf',
        match: ɵ0
    },
    {
        name: 'doc',
        mime: 'application/msword',
        extension: 'doc',
        match: ɵ1
    },
    {
        name: 'xls',
        mime: 'application/excel',
        extension: 'xls',
        match: ɵ2
    },
    {
        name: 'ppt',
        mime: 'application/vnd.ms-powerpoint',
        extension: 'ppt',
        match: ɵ3
    },
    {
        name: 'pptx',
        mime: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        extension: 'pptx',
        match: ɵ4
    },
    {
        name: 'docx',
        mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        extension: 'docx',
        match: ɵ5
    },
    {
        name: 'xlsx',
        mime: 'application/vnd.ms-excel',
        extension: 'xlsx',
        match: ɵ6
    },
    {
        name: 'xlsx',
        mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        extension: 'xlsx',
        match: ɵ7
    },
    {
        name: 'xml',
        mime: 'text/xml',
        extension: 'xml',
        match: ɵ8
    },
    {
        name: 'midi',
        mime: 'audio/midi',
        extension: 'midi',
        match: ɵ9
    },
    {
        name: 'mp3',
        mime: 'audio/mpeg',
        extension: 'mp3',
        match: ɵ10
    },
    {
        name: 'm4a',
        mime: 'audio/m4a',
        extension: 'm4a',
        match: ɵ11
    },
    {
        name: 'ogg',
        mime: 'audio/ogg',
        extension: 'ogg',
        match: ɵ12
    },
    {
        name: 'wav',
        mime: 'audio/x-wav',
        extension: 'wav',
        match: ɵ13
    },
    {
        name: 'amr',
        mime: 'audio/amr',
        extension: 'amr',
        match: ɵ14
    },
    {
        name: 'mp4',
        mime: 'video/mp4',
        extension: 'mp4',
        match: ɵ15
    },
    {
        name: 'm4v',
        mime: 'video/x-m4v',
        extension: 'm4v',
        match: ɵ16
    },
    {
        name: 'mkv',
        mime: 'video/x-matroska',
        extension: 'mkv',
        match: ɵ17
    },
    {
        name: 'webm',
        mime: 'video/webm',
        extension: 'webm',
        match: ɵ18
    },
    {
        name: 'mov',
        mime: 'video/quicktime',
        extension: 'mov',
        match: ɵ19
    },
    {
        name: 'avi',
        mime: 'video/x-msvideo',
        extension: 'avi',
        match: ɵ20
    },
    {
        name: 'wmv',
        mime: 'video/x-ms-wmv',
        extension: 'wmv',
        match: ɵ21
    },
    {
        name: 'flv',
        mime: 'video/x-flv',
        extension: 'flv',
        match: ɵ22
    },
    {
        name: 'mpg',
        mime: 'video/mpeg',
        extension: 'mpg',
        match: ɵ23
    },
    {
        name: 'jpg',
        mime: 'image/jpeg',
        extension: 'jpg',
        match: ɵ24
    },
    {
        name: 'png',
        mime: 'image/png',
        extension: 'png',
        match: ɵ25
    },
    {
        name: 'svg',
        mime: 'image/svg+xml',
        extension: 'svg',
        match: ɵ26
    },
    {
        name: 'gif',
        mime: 'image/gif',
        extension: 'gif',
        match: ɵ27
    },
    {
        name: 'webp',
        mime: 'image/webp',
        extension: 'webp',
        match: ɵ28
    },
    {
        name: 'cr2',
        mime: 'image/x-canon-cr2',
        extension: 'cr2',
        match: ɵ29
    },
    {
        name: 'tif',
        mime: 'image/tiff',
        extension: 'tif',
        match: ɵ30
    },
    {
        name: 'bmp',
        mime: 'image/bmp',
        extension: 'bmp',
        match: ɵ31
    },
    {
        name: 'heic',
        mime: 'image/heic',
        extension: 'heic',
        match: ɵ32
    },
    {
        name: 'heif',
        mime: 'image/heif',
        extension: 'heif',
        match: ɵ33
    },
    {
        name: 'jxr',
        mime: 'image/vnd.ms-photo',
        extension: 'jxr',
        match: ɵ34
    },
    {
        name: 'psd',
        mime: 'image/vnd.adobe.photoshop',
        extension: 'psd',
        match: ɵ35
    },
    {
        name: 'ico',
        mime: 'image/x-icon',
        extension: 'ico',
        match: ɵ36
    },
    {
        name: 'zip',
        mime: 'application/zip',
        extension: 'zip',
        match: ɵ37
    }
];

const FLAG_ARIA_LABEL = 'Phone number country code';
const PHONE_MASK_DEFAULT = '000-000-0000';
const LANGUAGE_CODES_BY_COUNTRY_CODES = {
    ae: ['ar'],
    af: ['ps'],
    al: ['sq'],
    ax: ['sv'],
    am: ['hy'],
    at: ['de'],
    az: ['az'],
    ba: ['bg'],
    bd: ['bn'],
    be: ['nl'],
    bg: ['bg'],
    bh: ['ar'],
    bi: ['rw'],
    bj: ['fr'],
    br: ['pt'],
    bs: ['ar'],
    bt: ['dz'],
    by: ['be'],
    cd: ['en', 'sw'],
    cg: ['en', 'fr'],
    cf: ['fr'],
    ch: ['de'],
    ci: ['*fr'],
    cm: ['fr'],
    cn: ['zh'],
    cv: ['tr'],
    cy: ['el'],
    cz: ['cs'],
    de: ['de'],
    dk: ['da'],
    do: ['es'],
    dz: ['ar'],
    ee: ['et'],
    eh: ['ar'],
    es: ['es'],
    eg: ['ar'],
    fi: ['fi'],
    fk: ['es'],
    fo: ['fo'],
    fr: ['*fr'],
    ge: ['ka'],
    gf: ['fr'],
    gh: ['hmn'],
    gl: ['fi'],
    gn: ['fr'],
    gr: ['el'],
    gw: ['pt'],
    gq: ['es'],
    hk: ['zh'],
    hr: ['hr'],
    hu: ['hu'],
    il: ['he'],
    it: ['it'],
    in: ['hi'],
    ir: ['fa'],
    iq: ['ar'],
    is: ['is'],
    jo: ['ar'],
    jp: ['ja'],
    kg: ['ky'],
    kh: ['km'],
    km: ['ar'],
    kp: ['ko'],
    kr: ['ko'],
    kw: ['ar'],
    kz: ['ru'],
    la: ['lo'],
    lb: ['ar'],
    lk: ['si'],
    lt: ['lt'],
    lv: ['lv'],
    ly: ['ar'],
    ma: ['ar'],
    md: ['ro'],
    me: ['hr'],
    mf: ['fr'],
    mg: ['mg'],
    mk: ['sq', 'mk'],
    mm: ['en', 'my'],
    mn: ['mn'],
    mo: ['zh'],
    mr: ['ar'],
    mu: ['la'],
    mx: ['es'],
    mz: ['pt'],
    na: ['af'],
    nc: ['fr'],
    ne: ['ha'],
    nl: ['nl'],
    no: ['nb'],
    np: ['ne'],
    om: ['ar'],
    pa: ['es'],
    pe: ['es'],
    pf: ['fr'],
    pk: ['ur'],
    pl: ['pl'],
    pm: ['fr'],
    ps: ['ar'],
    qa: ['ar'],
    re: ['*fr'],
    ro: ['ro'],
    rs: ['sr'],
    ru: ['ru'],
    sa: ['ar'],
    sd: ['ar'],
    se: ['sv'],
    si: ['sl'],
    sk: ['sk'],
    sn: ['fr'],
    so: ['so'],
    ss: ['ar'],
    st: ['pt'],
    sv: ['*es'],
    sy: ['ar'],
    td: ['fr'],
    th: ['th'],
    tn: ['ar'],
    tr: ['tr'],
    tw: ['zh'],
    ua: ['uk'],
    uz: ['uz'],
    va: ['it'],
    vn: ['vi'],
    wf: ['la'],
    ye: ['ar']
};
const UNSUPPORTED_INPUT_PHONE_COUNTRIES = [
    Country.China,
    Country.Indonesia,
    Country.Iran,
    Country.Iraq,
    Country.Malaysia,
    Country.RussianFederation,
    Country.Kazakhstan,
    Country.SriLanka
];
const INPUT_PHONE_CONFIG = new InjectionToken('INPUT_PHONE_CONFIG');
const DEFAULT_INPUT_PHONE_CONFIG = {
    initialCountry: Country.UnitedStates,
    onlyCountries: [],
    preferredCountries: [
        Country.UnitedStates,
        Country.UnitedKingdom
    ],
    excludeCountries: []
};

const DROPDOWN_ANIMATION_TIME = 300;
const MOBILE_SCREEN_WIDTH = 768;

const DEFAULT_NAVIGATION_MENU = [
    {
        id: 'dropdown-clinic',
        anchor: '#dropdown-clinic',
        menuIcon: 'dashboard',
        menuTitle: 'Clinic',
        subMenuType: 'menu',
        subMenu: [
            {
                items: [
                    { content: 'My Cases', value: 'my-cases' },
                    { content: 'All Cases', value: 'all-cases' },
                    { content: 'Patients', value: 'patients' }
                ]
            }
        ],
        favorite: true
    },
    {
        id: 'dropdown-calendar',
        anchor: '#dropdown-calendar',
        menuIcon: 'dashboard',
        menuTitle: 'Calendar',
        subMenuType: 'menu',
        subMenu: [
            {
                items: [
                    { content: 'My Calendar', value: 'my-calendar' },
                    { content: 'Provider Oncall Calendar', value: 'provider-oncal-calendar' },
                    { content: 'Callback Device Calendar', value: 'callback-device-calendar' },
                    { content: 'Patient Appointment Calendar', value: 'patient-appointment-calendar' }
                ]
            }
        ],
        favorite: true
    },
    {
        id: 'dropdown-collaborate',
        anchor: '#dropdown-collaborate',
        menuIcon: 'dashboard',
        menuTitle: 'Collaborate',
        favorite: true
    },
    {
        id: 'dropdown-tools',
        anchor: '#dropdown-tools',
        menuIcon: 'dashboard',
        menuTitle: 'Tools',
        subMenuType: 'menu',
        subMenu: [
            {
                items: [
                    { content: 'User Support & Help', value: 'user-suport-help' },
                    { content: 'Analytics Reports', value: 'analytics-reports' },
                    { content: 'System Settings', value: 'system-settings' }
                ]
            }
        ],
        favorite: true
    },
    {
        id: 'menu-item1',
        anchor: '#menu-item1',
        menuIcon: 'dashboard',
        menuTitle: 'Menu Item 1'
    },
    {
        id: 'menu-item2',
        anchor: '#menu-item2',
        menuIcon: 'dashboard',
        menuTitle: 'Menu Item 2',
        subMenuType: 'menu',
        subMenu: [
            {
                items: [
                    { content: 'Menu Sub item', value: 'menu-subitem' },
                    { content: 'Menu Sub item 2', value: 'menu-subitem2' },
                    { content: 'Menu Sub item 3', value: 'menu-subitem3' }
                ]
            }
        ]
    }
];

const buttonSize = 56;
const regularButtonSize = 36;
const modalOffset = 8;
const headerHeight = 72;
const dialogMinHeight = 300;
const dialogMinWidth = 300;
const dialogMaxWidth = 800;
const floatingDialogOffset = 24;
const defaultPosition = 'right';
const defaultOffset = 24;

var awFloatingDialog_constant = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttonSize: buttonSize,
    regularButtonSize: regularButtonSize,
    modalOffset: modalOffset,
    headerHeight: headerHeight,
    dialogMinHeight: dialogMinHeight,
    dialogMinWidth: dialogMinWidth,
    dialogMaxWidth: dialogMaxWidth,
    floatingDialogOffset: floatingDialogOffset,
    defaultPosition: defaultPosition,
    defaultOffset: defaultOffset
});

const SPACE_KEY_CODE = 32;
const ENTER_KEY_CODE = 13;
const TAB_KEY_CODE = 9;
const PAGE_UP_KEY_CODE = 33;
const PAGE_DOWN_KEY_CODE = 34;
const END_KEY_CODE = 35;
const HOME_KEY_CODE = 36;
const ARROW_LEFT_KEY_CODE = 37;
const ARROW_UP_KEY_CODE = 38;
const ARROW_RIGHT_KEY_CODE = 39;
const ARROW_DOWN_KEY_CODE = 40;
const ESCAPE_KEY_CODE = 27;

var keyCodes_constant = /*#__PURE__*/Object.freeze({
    __proto__: null,
    SPACE_KEY_CODE: SPACE_KEY_CODE,
    ENTER_KEY_CODE: ENTER_KEY_CODE,
    TAB_KEY_CODE: TAB_KEY_CODE,
    PAGE_UP_KEY_CODE: PAGE_UP_KEY_CODE,
    PAGE_DOWN_KEY_CODE: PAGE_DOWN_KEY_CODE,
    END_KEY_CODE: END_KEY_CODE,
    HOME_KEY_CODE: HOME_KEY_CODE,
    ARROW_LEFT_KEY_CODE: ARROW_LEFT_KEY_CODE,
    ARROW_UP_KEY_CODE: ARROW_UP_KEY_CODE,
    ARROW_RIGHT_KEY_CODE: ARROW_RIGHT_KEY_CODE,
    ARROW_DOWN_KEY_CODE: ARROW_DOWN_KEY_CODE,
    ESCAPE_KEY_CODE: ESCAPE_KEY_CODE
});

const SCROLL_TIME_LIST_FORWARD = 'Scroll list of available times forward';
const SCROLL_TIME_LIST_BACK = 'Scroll list of available times back';
const PLAY_BUTTON = 'Play';
const STOP_BUTTON = 'Stop';

const DATEPICKER_SEARCH_TYPING_DELAY = 500;

const TIMEPICKER_MASK_PATTERNS = {
    '0': {
        pattern: new RegExp('\\d')
    },
    '1': {
        pattern: new RegExp('[01]')
    },
    '2': {
        pattern: new RegExp('[0-2]')
    },
    '5': {
        pattern: new RegExp('[0-5]')
    },
    '9': {
        pattern: new RegExp('\\d'),
        optional: true
    },
    X: {
        pattern: new RegExp('\\d'),
        symbol: '*'
    },
    a: {
        pattern: new RegExp('[aApP]')
    },
    b: {
        pattern: new RegExp('[mM]')
    },
    A: {
        pattern: new RegExp('[a-zA-Z0-9]')
    },
    S: {
        pattern: new RegExp('[a-zA-Z]')
    },
    d: {
        pattern: new RegExp('\\d')
    },
    m: {
        pattern: new RegExp('\\d')
    },
    M: {
        pattern: new RegExp('\\d')
    },
    H: {
        pattern: new RegExp('\\d')
    },
    h: {
        pattern: new RegExp('\\d')
    },
    s: {
        pattern: new RegExp('\\d')
    },
    R: {
        pattern: new RegExp('[+-]'),
        symbol: '+'
    }
};

const DISABLED_TOOLTIP_TEXT = 'This action is not available to you until the required actions are completed.';

export { AW_ATTACHMENT_EXTENSIONS, AW_CHART_BORDERS_DEFAULT, AW_CHART_OPTIONS_DEFAULT, AW_NEW_ATTACHMENT_EXTENSIONS, CHART_BORDER_DASH_1, CHART_BORDER_DASH_2, CHART_BORDER_DASH_3, CHART_BORDER_DASH_4, CHART_BORDER_DASH_5, CHART_BORDER_DASH_6, CHART_BORDER_DASH_7, CHART_BORDER_DASH_8, CHART_BORDER_SOLID, DATEPICKER_SEARCH_TYPING_DELAY, DEFAULT_INPUT_PHONE_CONFIG, DEFAULT_NAVIGATION_MENU, DISABLED_TOOLTIP_TEXT, DROPDOWN_ANIMATION_TIME, FLAG_ARIA_LABEL, awFloatingDialog_constant as FloatingDialogConstants, INPUT_PHONE_CONFIG, keyCodes_constant as KeyCode, LANGUAGE_CODES_BY_COUNTRY_CODES, MAGIC_BYTES, MOBILE_SCREEN_WIDTH, PHONE_MASK_DEFAULT, PLAY_BUTTON, SCROLL_TIME_LIST_BACK, SCROLL_TIME_LIST_FORWARD, STOP_BUTTON, SUPPORTED_FILE_TYPES, TIMEPICKER_MASK_PATTERNS, UNSUPPORTED_INPUT_PHONE_COUNTRIES };

//# sourceMappingURL=aw-ads-components-src-constants.js.map